module.exports = __webpack_public_path__ + "img/coconala_merit1.a6f98fd.jpg";